<template>
  <div class="mk-glass">
    <div class="mk-glass__container">
      <div class="mk-glass__buttons">
        <button
          class="mk-glass__add-glass"
          @click="removeSectionObject"
          v-if="objectSections.length > 0"
        >
          <div class="mk-glass__add-glass__container">
            <span class="mk-glass__add-glass__check">-</span>
            <span class="mk-glass__add-glass__text">
              {{$t('glasses.undo')}}
            </span>
          </div>
          <span
            class="mk-glass__add-glass__subtitle"
          >
            ({{$t('glasses.removesLast')}})
          </span>
        </button>
        <button
          class="mk-glass__add-glass"
          @click="selectGlasses"
          v-if="
            !finished
            && (objectSections[objectSections.length - 1]
              && objectSections[objectSections.length - 1].connector
              && !objectSections[objectSections.length - 1].glass)
            || objectSections.length === 0
          "
        >
          <div class="mk-glass__add-glass__container">
            <span class="mk-glass__add-glass__check">+</span>
            <span class="mk-glass__add-glass__text">
              {{objectSections.length === 0 ? $t('glasses.start') : $t('glasses.continue')}}
            </span>
          </div>
          <span
            class="mk-glass__add-glass__subtitle"
            v-if="objectSections.length === 0"
          >
            ({{$t('glasses.addFirstStand')}})
          </span>
          <span
            class="mk-glass__add-glass__subtitle"
            v-if="objectSections.length !== 0"
          >
            ({{$t('glasses.addsNextGlass')}})
          </span>
        </button>
        <button
          class="mk-glass__add-glass"
          @click="selectConnector"
          v-if="
            objectSections[objectSections.length - 1]
            && objectSections[objectSections.length - 1].glass
          "
        >
          <div class="mk-glass__add-glass__container">
            <span class="mk-glass__add-glass__check">+</span>
            <span class="mk-glass__add-glass__text">
              {{$t('glasses.continue')}}
            </span>
          </div>
          <span
            class="mk-glass__add-glass__subtitle"
          >
            ({{$t('glasses.addsNextConnector')}})
          </span>
        </button>
        <button
          class="mk-glass__add-glass  mk-glass__add-glass--primary"
          @click="finishConfiguration"
          v-if="
            objectSections[objectSections.length - 1]
            && objectSections[objectSections.length - 1].glass
          "
        >
          <div class="mk-glass__add-glass__container">
            <span class="mk-glass__add-glass__check"><Check /></span>
            <span>
              {{$t('glasses.finish')}}
            </span>
          </div>
          <span class="mk-glass__add-glass__subtitle">
            ({{$t('glasses.addLastStand')}})
          </span>
        </button>
      </div>
      <div class="mk-glass__offset">
        <p class="mk-glass__offset__description">
          <b>Offset</b> - {{$t('glasses.offset')}}
        </p>
        <SizeInput
          :label="$t('glasses.offsetInDepth')"
          :value="offset.x"
          :focusCallback="()=>{}"
          :updateValue="(value)=>{$store.dispatch('setOffset', {x: value})}"
          :isImperial="!metric"
          :maxValue="500"
          :minValue="0"
        />
        <SizeInput
          :label="$t('glasses.offsetInLength')"
          :value="offset.y"
          :focusCallback="()=>{}"
          :updateValue="(value)=>{$store.dispatch('setOffset', {y: value})}"
          :isImperial="!metric"
          :maxValue="2000"
          :minValue="10"
        />
         <button
          class="mk-glass__add-glass"
          :class="showCenterDistance?'mk-glass__add-glass--selected':''"
          @click="$store.dispatch('setShowCenterDistance', showCenterDistance ? false: true)"
        >
          <div class="mk-glass__add-glass__container">
            <RulerSquare class="mk-glass__add-glass__check"/>
            <span>
              {{$t('glasses.distancesCenter')}}
            </span>
          </div>
        </button>
      </div>

      <div class="mk-glass__objects">
        <span class="mk-glass__edit-text">
          <div v-if="!finished" class="mk-glass__edit-text">
            <PencilOutline class="mk-glass__edit-text__icon"/>
            {{$t('glasses.clickOnElement')}}
          </div>
          <span v-if="finished" class="mk-glass__finished">
            <span class="mk-glass__finished__head">
              {{$t('glasses.configurationFinishedTitle')}}
            </span>
            {{$t('glasses.configurationFinishedSubtitle')}}
          </span>
        </span>
        <div class="mk-glass__objects__list" ref="objectList">
          <div
            class="mk-glass__objects__section"
            v-for="(section, index) in objectSections"
            :key="`section-${index}`"
          >
            <div class="mk-glass__objects__connection">
              <div class="mk-glass__row-element">
                <SelectionConnectorObject
                  v-if="section.connector && index !== 0"
                  :object="section.connector"
                  :clickCallback="() => {editClicked(index, section.connector)}"
                />
              </div>
              <div class="mk-glass__row-element">
                <SelectionStandObject
                  v-if="section.stand"
                  :object="section.stand"
                  :index="index"
                  :standApproval="standApproval"
                  :clickCallback="() => {editClicked(index, section.stand)}"
                />
                <Tooltip
                  :shown="index === objectSections.length - 1 && !newObjectList"
                  :tooltipText="$t('glasses.standPopup')"
                  v-if="
                    section.connector.angle === 0
                    && !section.stand
                    && standApproval[index]
                    && standApproval[index].stand
                  "
                >
                  <button
                    class="mk-button mk-glass__add-stand"
                    name="standPopup"
                    @click="() => { addStand(
                      index,
                      clampApproval[index],
                      section.clamp1 ? section.clamp1 : section.clamp2,
                    )}"
                  >
                    +
                  </button>
                </Tooltip>
              </div>

              <div class="mk-glass__row-element">
                 <Tooltip
                  :shown="shouldDisplayClampPopup(index) && !newObjectList"
                  :tooltipText="$t('glasses.clampPopup')"
                  v-if="
                      (section.connector.angle === 0
                        || section.stand && index === objectSections.length -1)
                      && !section.clamp1 && !section.clamp2
                      && section.stand
                      && section.stand.isClampApproved
                      && checkIfAClampFits(clampApproval[index]).length > 0
                    "
                >
                  <button
                    class="mk-button mk-glass__add-stand"
                    @click="() => { addClamp(index, clampApproval[index]) }"
                  >
                    +
                  </button>
                </Tooltip>

                <SelectionClampObject
                  v-if="section.clamp1 || section.clamp2"
                  :object="section.clamp1 ? section.clamp1 : section.clamp2"
                  :clickCallback="() => {
                    editClicked(index, section.clamp1 ? section.clamp1 : section.clamp2)
                  }"
                />
              </div>
            </div>
            <SelectionGlassObject
              class="mk-glass__objects__glass"
              v-if="section.glass"
              :object="section.glass"
              :clickCallback="() => {editClicked(index, section.glass)}"
            />
          </div>
        </div>
      </div>
    </div>
    <ObjectSelectionPopup
      :objects="newObjectList"
      :updateIndex="updateIndex"
      :clampApproval="newObjectClampApproval"
      :closeCallback="() => {newObjectList = null; updateIndex = null}"
      v-if="newObjectList"
    />
  </div>
</template>

<script>
/**
 * Glass Selection
 * @author David <david.prenninger@gmx.de>
 *
 * This component is part of the main configurator Sections.
 * It presents the user offset inputs and a basic representation of the configuration state.
 * Depending on the state, this component enables the user to add new products to the configuration.
 *
 */
import Check from 'vue-material-design-icons/CheckOutline.vue';
import PencilOutline from 'vue-material-design-icons/PencilOutline.vue';
import RulerSquare from 'vue-material-design-icons/RulerSquare.vue';
import SizeInput from '@/components/SizeInput.vue';
import ObjectSelectionPopup from '@/components/ObjectSelectionPopup.vue';
import {
  checkIfLastObjectPointInArea,
  checkIfPointIsClampApproved,
  checkForStandApproval,
} from '@/helpers/dimensions';
import SelectionConnectorObject from '@/components/SelectionConnectorObject.vue';
import SelectionStandObject from '@/components/SelectionStandObject.vue';
import SelectionGlassObject from '@/components/SelectionGlassObject.vue';
import SelectionClampObject from '@/components/SelectionClampObject.vue';

import Tooltip from '@/components/Tooltip.vue';

import { serializeSectionObject, serializeFinish } from '../helpers/url';


export default {
  data() {
    return {
      newObjectList: null,
      updateIndex: null,
      newObjectClampApproval: undefined,
      sectionObjectSize: 0,
    };
  },
  components: {
    SizeInput,
    ObjectSelectionPopup,
    SelectionGlassObject,
    SelectionStandObject,
    SelectionClampObject,
    SelectionConnectorObject,
    Check,
    PencilOutline,
    Tooltip,
    RulerSquare,
  },
  computed: {
    showCenterDistance() {
      return this.$store.getters.showCenterDistance;
    },
    offset() {
      return this.$store.getters.offset;
    },
    objectSections() {
      return this.$store.getters.objectSections;
    },
    dimensions() {
      return this.$store.getters.dimensions;
    },
    clampApproval() {
      return this.$store.getters.clampApproval;
    },
    standApproval() {
      return this.$store.getters.standApproval;
    },
    metric() {
      return this.$store.getters.metric;
    },
    finished() {
      return this.$store.getters.finish;
    },
    productsStands() {
      return this.$store.getters.stands;
    },
    productsConnectors() {
      return this.$store.getters.connectors;
    },
    productClamps() {
      return this.$store.getters.clamps;
    },
    productsStandardGlasses() {
      return this.$store.getters.standardGlasses;
    },
    productsExtensionGlasses() {
      return this.$store.getters.extensionGlasses;
    },
    inlineConnector() {
      return this.$store.getters.inLineConnector;
    },
    endConnector() {
      return this.$store.getters.endConnector;
    },
    clampApprovedStands() {
      return this.$store.getters.clampApprovedStands;
    },
  },
  watch: {
    objectSections() {
      checkIfPointIsClampApproved(
        this.objectSections,
        this.dimensions,
        this.offset,
        this,
      );
      checkForStandApproval(
        this.objectSections,
        this.dimensions,
        this.offset,
        this,
      );
      if (!checkIfLastObjectPointInArea(this.objectSections, this.dimensions, this.offset)) {
        this.$store.dispatch('setVisualizationWarning', this.$t('warnings.glassBorder'));
      }
      setTimeout(() => {
        this.$refs.objectList.scrollTop = this.$refs.objectList.scrollHeight;
        this.$refs.objectList.scrollLeft = this.$refs.objectList.scrollWidth;
      }, 10);
    },
  },
  methods: {
    // Opens ObjectSelectionPopup to select a glass.
    selectGlasses() {
      const standard = this.productsStandardGlasses;
      const extension = this.productsExtensionGlasses;
      standard.sort((a, b) => a.width - b.width);
      extension.sort((a, b) => a.width - b.width);
      this.newObjectList = {
        standard,
        extension,
      };
    },
    // Opens ObjectSelectionPopup to select a connector.
    selectConnector() {
      this.newObjectList = {
        standard: this.productsConnectors,
      };
    },
    // Opens ObjectSelectionPopup to edit or remove the clicked object.
    // This is depending on the selected item type.
    editClicked(index, object) {
      this.updateIndex = index;
      if (object.type === 'standard-glass' || object.type === 'extension-glass') {
        this.newObjectList = {
          standard: this.productsStandardGlasses,
          extension: this.productsExtensionGlasses,
        };
      } else if (object.type === 'connector') {
        if (index === 0) {
          return;
        }
        if (this.objectSections[index].stand) {
          this.newObjectList = { standard: [this.inlineConnector] };
          if (index === this.objectSections.length - 1) {
            this.$store.dispatch('setFinish', false);
            serializeFinish(false, this);
          }
        } else {
          this.newObjectList = {
            standard: this.productsConnectors,
          };
        }
      } else if (object.type === 'stand') {
        if (index === this.objectSections.length - 1) {
          // Changeing last Stand
          this.addStand(index, this.clampApproval, this.objectSections[index].clamp);
        } else {
          // Delete Stand if clicked on item
          this.$store.dispatch('setSectionObject', { index, data: { stand: undefined } });
        }
      } else if (object.type === 'clamp') {
        // Delete Clamp if clicked on item
        this.$store.dispatch('setSectionObject', { index, data: { clamp1: undefined, clamp2: undefined } });
        if (index === this.objectSections.length - 1) {
          this.$store.dispatch('setFinish', false);
          serializeFinish(false, this);
        }
      }
    },
    // Opens ObjectSelectionPopup to select a stand or if possible a single clamp
    addStand(index, clampApproval, clamp) {
      if (clamp) {
        this.newObjectList = { standard: this.clampApprovedStands };
      } else {
        this.newObjectClampApproval = clampApproval;
        const clamps = this.checkIfAClampFits(clampApproval);
        const selectedStands = this.productsStands.filter(
          (stand) => this.standApproval[0].stand.distanceBack >= stand.length / 2 - 0.01
          && this.standApproval[0].stand.distanceFront >= stand.length / 2 - 0.01,
        );
        this.newObjectList = { ...{ standard: selectedStands }, clamps };
      }
      this.updateIndex = index;
    },
    // Opens ObjectSelectionPopup to select a clamp
    addClamp(index, clampApproval) {
      this.newObjectClampApproval = clampApproval;
      const clamps = this.checkIfAClampFits(clampApproval);
      this.newObjectList = { clamps };
      this.updateIndex = index;
    },
    // Sets finished state + adds last stand and connector
    finishConfiguration() {
      this.$store.dispatch('setFinish', true);
      const standList = [...this.productsStands];
      standList.sort((a, b) => b.length - a.length);
      console.log(this.standApproval[this.standApproval.length - 1]);
      let selectedStands = standList.filter(
        (stand) => this.standApproval[this.standApproval.length - 1]
          .stand.distanceBack >= stand.length / 2
        && this.standApproval[this.standApproval.length - 1]
          .stand.distanceFront >= stand.length / 2,
      );
      if (selectedStands.length === 0) {
        // this.$store.dispatch('setVisualizationWarning',
        // 'No space for last stand -> Configuration can not be finished.');
        selectedStands = [...this.productsStands];
        selectedStands.sort((a, b) => a.length - b.length);
      }
      this.$store.dispatch('setSectionObject', { data: { stand: selectedStands[0], connector: this.endConnector } });
      serializeSectionObject(this.objectSections, this);
      serializeFinish(true, this);
    },
    // Removes last section Object
    removeSectionObject() {
      this.$store.dispatch('removeLastSectionObject');
      serializeSectionObject(this.objectSections, this);
      if (this.finished) {
        this.$store.dispatch('setFinish', false);
        serializeFinish(false, this);
      }
    },
    // Iterates over all clamps and returns list of all fitting clamps
    checkIfAClampFits(clampApproval) {
      return this.productClamps.filter((clamp) => this.checkIfClampFits(
        clamp.maxExtension / 1000,
        clamp.minExtension / 1000,
        clampApproval,
      ));
    },
    // Checks if a clamp fits at a position
    checkIfClampFits(max, min, clampApproval) {
      return ((
        clampApproval.first
        && clampApproval.first.distanceBack <= max + 0.00001
        && clampApproval.first.distanceBack >= min - 0.00001
        && clampApproval.first.distanceFront <= max + 0.00001
        && clampApproval.first.distanceFront >= min - 0.00001
      ) || (
        clampApproval.second
        && clampApproval.second.distanceBack <= max + 0.00001
        && clampApproval.second.distanceBack >= min
        && clampApproval.second.distanceFront <= max + 0.00001
        && clampApproval.second.distanceFront >= min - 0.00001
      ));
    },
    shouldDisplayClampPopup(itemIndex) {
      let maxIndex = 0;
      this.objectSections.forEach((section, index) => {
        if (section.connector.angle === 0
            && !section.clamp1 && !section.clamp2
            && section.stand
            && section.stand.isClampApproved
            && this.checkIfAClampFits(this.clampApproval[index]).length > 0
        ) {
          maxIndex = index;
        }
      });
      return itemIndex === maxIndex;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/defaults.scss";

.mk-glass {
  @media (max-width: 900px) {
    height: 60%;
  }

  &__container  {
    position: relative;
    height: 280px;
    width: 100%;
    border-top: 1px solid $c_primary_light;
    display: flex;

    @media (max-width: 900px) {
      flex-direction: column;
      align-items: center;
      height: 100%;
    }
  }

  &__finished {
    display: flex;
    background-color: $c_green;
    padding: 5px 10px;
    color: $c_white;
    flex-direction: column;
    font-size: 12px;
    margin-bottom: 10px;

    &__head {
      font-weight: 500;
      font-size: 14px;
    }
  }

  &__offset {
    display: flex;
    flex-direction: column;
    align-items: center;
    border-right: 1px solid $c_primary_light;
    padding: 10px;
    flex: 0 0 250px;
    box-sizing: content-box;

    @media (max-width: 900px) {
      border-right: none;
      border-bottom: 1px solid $c_primary_light;
    }

    &__title {
      font-weight: 500;
    }

    &__description {
      text-align: left;
      font-size: 12px;
      line-height: normal;
      margin: 0px;
    }
  }

  &__buttons {
    position: absolute;
    top: -80px;
    z-index: 3;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 20px 10px;
    width: 100%;
    box-sizing: border-box;
    pointer-events: none;

    @media (max-width: 900px) {
      flex-direction: column;
      top: -430px;
      height: 400px;
      justify-content: flex-end;
    }
  }

  &__add-glass {
    margin: 5px;
    border: none;
    background-color: $c_white;
    box-shadow: $bs_md;
    box-sizing: border-box;
    border-radius: $br_md;
    padding: 5px 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    pointer-events: all;

    &__text {
      text-transform: uppercase;
      font-weight: bold;
    }

    &:not(.toggle) {
      background-color: $c_white;
    }

    &--primary {
      background-color: $c_accent;
      color: $c_white;
      margin-left: 20px;

      @media (max-width: 900px) {
        margin-left: 0;
      }

      &:not(.toggle) {
        background-color: $c_accent;
      }
    }

    &--selected {
      border: 2px solid $c_primary;
    }

    &__container {
      display: flex;
      height: 20px;
      align-items: center;
    }

    &__subtitle {
      font-size: 12px;
      font-weight: normal;
      text-transform: none;
    }

    &__check {
      font-size: 20px;
      margin-right: 5px;
      width: 20px;
    }
  }

  &__add-stand {
    background-color: $c_accent;
    border: none;
    margin: 10px;
    color: $c_white;
    border-radius: 50%;
    box-sizing: border-box;
    height: 30px;
    width: 30px;
    display: flex;
    justify-content: center;
    align-items: center;

    &:not(.toggle) {
      background-color: $c_accent;
    }
  }

  &__edit-text {
    display: flex;
    color: $c_primary_lighter;
    font-size: 12px;
    margin-bottom: 5px;
    align-items: center;

    &__icon {
      font-size: 14px;
      margin-right: 5px;
    }
  }

  &__row-element {
    flex-grow: 1;
    flex-basis: 0;
  }

  &__objects {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: calc(100% - 40px);
    padding: 0 20px;
    padding-top: 10px;
    box-sizing: border-box;
    justify-content: flex-start;
    overflow: hidden;

    &__list {
      display: flex;
      width: 100%;
      box-sizing: border-box;
      scroll-behavior: smooth;
      flex-grow: 1;
      overflow: auto;

      @media (max-width: 900px) {
        display: grid;
        grid-template-columns: repeat( auto-fit, minmax(140px, max-content));
        padding: 5px;
        box-sizing: border-box;
      }

    }

    &__glass {
      align-self: flex-start;
    }

    &__connection {
      display: flex;
      flex-direction: column;
      padding-top: 40px;
      box-sizing: border-box;
    }

    &__section {
      display: flex;
      align-items: center;
    }
  }
}
</style>
